var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToDo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9974 2.33398H6.9974C5.70873 2.33398 4.66406 3.37865 4.66406 4.66732V23.334C4.66406 24.6227 5.70873 25.6673 6.9974 25.6673H20.9974C22.2861 25.6673 23.3307 24.6227 23.3307 23.334V4.66732C23.3307 3.37865 22.2861 2.33398 20.9974 2.33398Z",
    fill: "#E7ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2383 9.33301H7.58333C7.26117 9.33301 7 9.59418 7 9.91634V11.083C7 11.4052 7.26117 11.6663 7.58333 11.6663H12.2383C12.5605 11.6663 12.8217 11.4052 12.8217 11.083V9.91634C12.8217 9.59418 12.5605 9.33301 12.2383 9.33301Z",
    fill: "#C7CED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.502 10.0168L20.1771 7.3418L21.827 8.99171L17.502 13.3167L14.3438 10.1584L15.9937 8.50846L17.502 10.0168Z",
    fill: "#48AFBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.502 17.0168L20.1771 14.3418L21.827 15.9917L17.502 20.3167L14.3438 17.1584L15.9937 15.5085L17.502 17.0168Z",
    fill: "#48AFBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2461 16.334H7.59115C7.26898 16.334 7.00781 16.5952 7.00781 16.9173V18.119C7.00781 18.4411 7.26898 18.7023 7.59115 18.7023H12.2461C12.5683 18.7023 12.8295 18.4411 12.8295 18.119V16.9173C12.8295 16.5952 12.5683 16.334 12.2461 16.334Z",
    fill: "#C7CED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToDo);
export default __webpack_public_path__ + "static/media/icon_to-do.a94bdb02f234ada5b236d3a23b3c32c3.svg";
export { ForwardRef as ReactComponent };